module.exports = __webpack_public_path__ + "img/bg.fdeca7a4.png";